import {arrayToCsv} from '@netx/core-next/utils/array';
import {CUSTOM_FORM_KEY_PREFIX} from '../constants';

/**
 * We allow for overriding internal object props with custom form values\
 * And in some cases we allow for arbitrary storing custom form key/values
 * @param data Form data
 * @param internalKeys Keys that would not be considered part of custom form data
 */
export const deriveCustomFormValues = <
	T extends object,
	D extends Record<string, any> = Record<string, any>,
>(
	data: D,
	internalKeys: (keyof T)[] = [],
) => {
	const customValues: Record<string, string> = {};
	const internalValues: Partial<T> = {};

	for (const key in data) {
		const customKey = key.startsWith(CUSTOM_FORM_KEY_PREFIX);
		const name = customKey ? key.replace(CUSTOM_FORM_KEY_PREFIX, '') : key;
		const matchesInternalKey = internalKeys.includes(name as keyof T);

		if (customKey && !matchesInternalKey) {
			customValues[name] = Array.isArray(data[key])
				? arrayToCsv(data[key])
				: typeof data[key] === 'boolean'
				? data[key]
				: // strigify to handle any edge cases - it may not look pretty but at least it wont "break"
				  String(data[key]);
		} else if (
			matchesInternalKey &&
			(!customKey || internalValues[name as keyof T] == null)
		) {
			internalValues[name as keyof T] = data[key];
		}
	}

	return {customValues, internalValues};
};

export default deriveCustomFormValues;
